import { useCallback } from 'react';
import { useMapVisualization } from './useMapVisualization';

export const useMapUpdater = (mapRefs, formatDate, formatTime, handleMapClick) => {
  // Используем хук визуализации карты
  const {
    updateMapWithTrackDataInternal,
    updateMapView,
    refreshMapView,
    updateAnimatedMarker,
    clearHighlightedSegment
  } = useMapVisualization(mapRefs, formatDate, formatTime, handleMapClick);

  // Основная функция обновления карты с данными трека
  const updateMapWithTrackData = useCallback((data, currentVehicle, initializeMap) => {
    if (!data || data.length === 0) {
      console.warn('TrackReport: Нет данных для обновления карты');
      return;
    }

    console.log('TrackReport: Обновление карты с данными трека...');
    
    // Увеличиваем задержку перед обновлением карты для гарантии готовности DOM
    setTimeout(() => {
      if (!mapRefs.mapInstanceRef.current) {
        console.warn('TrackReport: Экземпляр карты не найден, инициализируем карту заново');
        if (mapRefs.mapContainerRef.current) {
          // Если контейнер есть, но карты нет - инициализируем карту заново
          initializeMap();
          // После инициализации попробуем обновить данные
          setTimeout(() => {
            if (mapRefs.mapInstanceRef.current) {
              const success = updateMapWithTrackDataInternal(data, currentVehicle, handleMapClick);
              if (success) {
                // Отображаем весь трек на карте только если обновление было успешным
                setTimeout(() => updateMapView(data), 200);
              }
            }
          }, 500);
        } else {
          console.error('TrackReport: Контейнер карты не найден, дожидаемся появления в DOM');
          // Ждем более долгое время для полной перерисовки DOM
          setTimeout(() => {
            if (mapRefs.mapContainerRef.current) {
              initializeMap();
              setTimeout(() => {
                if (mapRefs.mapInstanceRef.current) {
                  const success = updateMapWithTrackDataInternal(data, currentVehicle, handleMapClick);
                  if (success) {
                    // Отображаем весь трек на карте только если обновление было успешным
                    setTimeout(() => updateMapView(data), 200);
                  }
                }
              }, 500);
            } else {
              console.error('TrackReport: Контейнер карты все еще не найден после ожидания, невозможно обновить данные');
            }
          }, 1000);
        }
        return;
      }
      
      const success = updateMapWithTrackDataInternal(data, currentVehicle, handleMapClick);
      
      if (!success) {
        // Если обновление не удалось (например, контейнер был удален), реинициализируем карту
        console.log('TrackReport: Обновление карты не удалось, пытаемся реинициализировать');
        if (mapRefs.mapContainerRef.current && document.body.contains(mapRefs.mapContainerRef.current)) {
          setTimeout(() => {
            initializeMap();
            setTimeout(() => {
              if (mapRefs.mapInstanceRef.current) {
                const retrySuccess = updateMapWithTrackDataInternal(data, currentVehicle, handleMapClick);
                if (retrySuccess) {
                  // Отображаем весь трек на карте только если повторное обновление было успешным
                  setTimeout(() => updateMapView(data), 200);
                }
              }
            }, 500);
          }, 100);
        } else {
          console.warn('TrackReport: Контейнер карты недоступен для реинициализации');
        }
        return;
      }
      
      // Отображаем весь трек на карте с увеличенной безопасностью только если обновление было успешным
      setTimeout(() => {
        const viewSuccess = updateMapView(data);
        if (!viewSuccess && mapRefs.mapContainerRef.current && document.body.contains(mapRefs.mapContainerRef.current)) {
          // Если обновление вида не удалось, тоже пытаемся реинициализировать
          console.log('TrackReport: Обновление вида карты не удалось, реинициализируем');
          setTimeout(() => {
            initializeMap();
            setTimeout(() => {
              if (mapRefs.mapInstanceRef.current) {
                updateMapWithTrackDataInternal(data, currentVehicle, handleMapClick);
                setTimeout(() => updateMapView(data), 200);
              }
            }, 500);
          }, 100);
        }
      }, 200);
      
    }, 300);
  }, [mapRefs, updateMapWithTrackDataInternal, updateMapView, handleMapClick]);

  return {
    updateMapWithTrackData,
    updateMapView,
    refreshMapView,
    updateAnimatedMarker,
    clearHighlightedSegment
  };
}; 